import React, { PureComponent } from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import LoadingIndicactor from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import CrownIcon from "images/CrownIcon.svg";

import ModelBoxContainer from "containers/Business/ModelBox/ModelBox";
import ModelContainer from "containers/Business/ModelBox/Model";
import TestPredictionsContainer from "containers/Business/TestPredictions/TestPredictions";
import FeatureChartContainer from "containers/FeatureChart/FeatureChart";

import styles from "./style.module.css";

export default class ModelList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { mode: "MODEL", sortMode: "PROFIT" };
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  modelOrganizer = (modelGroup) => {
    const { sortMode } = this.state;

    if (!modelGroup || modelGroup.numModels === 0) {
      return null;
    }

    let rejectedModels =
      modelGroup.segment &&
      modelGroup.segment.job &&
      modelGroup.segment.job.data &&
      modelGroup.segment.job.data.rejected;

    //check project object in case of overall that doesn't have segment data inside of the modelgroup object
    if (!rejectedModels) {
      const { project } = this.props;
      const overallSegment = project && project.segments && project.segments.length === 1 && project.segments[0];
      if (overallSegment) {
        rejectedModels = overallSegment.job && overallSegment.job.data && overallSegment.job.data.rejected;
      }
    }

    let organizedList;

    if (rejectedModels) {
      const excludedModels = modelGroup.modelList.filter((model) => rejectedModels.includes(model.id));
      const includedModels = modelGroup.modelList.filter((model) => !rejectedModels.includes(model.id));
      organizedList = [...includedModels, ...excludedModels];
    } else {
      organizedList = modelGroup.modelList;
    }

    let maxProfit = -Infinity;
    let maxRevenue = -Infinity;
    let minResource = Infinity;
    let maxAccuracy = -Infinity;
    let maxPrecision = -Infinity;
    let maxRecall = -Infinity;
    let minLogLoss = Infinity;

    let maxProfitModel = undefined;
    let maxRevenueModel = undefined;
    let minResourceModel = undefined;
    let maxAccuracyModel = undefined;
    let maxPrecisionModel = undefined;
    let maxRecallModel = undefined;
    let minLogLossModel = undefined;

    for (let model of organizedList) {
      if (model.checkMax > maxProfit) {
        maxProfit = model.checkMax;
        maxProfitModel = model;
      }

      if (model.maxIteration && model.maxIteration.totalWins > maxRevenue) {
        maxRevenue = model.maxIteration.totalWins;
        maxRevenueModel = model;
      }

      if (model.maxIteration && model.maxIteration.bestResource < minResource) {
        minResource = model.maxIteration.bestResource;
        minResourceModel = model;
      }

      if (model.maxIteration && model.maxIteration.accuracy > maxAccuracy) {
        maxAccuracy = model.maxIteration.accuracy;
        maxAccuracyModel = model;
      }

      if (model.metadata && model.maxIteration.precision > maxPrecision) {
        maxPrecision = model.maxIteration.precision;
        maxPrecisionModel = model;
      }

      if (model.metadata && model.metadata.recall_score > maxRecall) {
        maxRecall = model.metadata.recall_score;
        maxRecallModel = model;
      }

      if (model.metadata && model.metadata.log_loss < minLogLoss) {
        minLogLoss = model.metadata.log_loss;
        minLogLossModel = model;
      }
    }

    if (maxProfitModel) {
      maxProfitModel.isMaxProfit = true;
    }

    if (maxRevenueModel) {
      maxRevenueModel.isMaxRevenue = true;
    }

    if (minResourceModel) {
      minResourceModel.isMinResource = true;
    }

    if (maxAccuracyModel) {
      maxAccuracyModel.isMaxAccuracy = true;
    }

    if (maxPrecisionModel) {
      maxPrecisionModel.isMaxPrecision = true;
    }

    if (maxRecallModel) {
      maxRecallModel.isMaxRecall = true;
    }

    if (minLogLossModel) {
      minLogLossModel.isMinLogLoss = true;
    }

    return organizedList.sort((a, b) => {
      if (sortMode === "PROFIT") {
        return a.checkMax < b.checkMax ? 1 : a.checkMax > b.checkMax ? -1 : 0;
      } else if (sortMode === "REVENUE" && a.maxIteration && b.maxIteration) {
        return a.maxIteration.totalWins < b.maxIteration.totalWins
          ? 1
          : a.maxIteration.totalWins > b.maxIteration.totalWins
            ? -1
            : 0;
      } else if (sortMode === "ACCURACY" && a.maxIteration && b.maxIteration) {
        return a.maxIteration.accuracy < b.maxIteration.accuracy
          ? 1
          : a.maxIteration.accuracy > b.maxIteration.accuracy
            ? -1
            : 0;
      } else if (sortMode === "RECALL" && a.metadata && b.metadata) {
        return a.metadata.recall_score < b.metadata.recall_score
          ? 1
          : a.metadata.recall_score > b.metadata.recall_score
            ? -1
            : 0;
      } else if (sortMode === "PRECISION" && a.metadata && b.metadata) {
        return a.maxIteration.precision < b.maxIteration.precision
          ? 1
          : a.maxIteration.precision > b.maxIteration.precision
            ? -1
            : 0;
      } else if (sortMode === "LOGLOSS" && a.metadata && b.metadata) {
        return a.metadata.log_loss > b.metadata.log_loss ? 1 : a.metadata.log_loss < b.metadata.log_loss ? -1 : 0;
      } else if (sortMode === "RESOURCING" && a.maxIteration && b.maxIteration) {
        return a.maxIteration.bestResource > b.maxIteration.bestResource
          ? 1
          : a.maxIteration.bestResource < b.maxIteration.bestResource
            ? -1
            : 0;
      }
    });
  };

  renderDrivers(topDrivers) {
    const { updateModelFeedback, isNoInteractions } = this.props;

    const feedbackCount =
      topDrivers && topDrivers.bestModel && topDrivers.segment && topDrivers.segment.roles
        ? topDrivers.segment.roles.reduce(
            (a, b) =>
              a +
              (b &&
              b.preferences &&
              b.preferences.feedback &&
              b.preferences.feedback[topDrivers.bestModel.id] !== undefined
                ? Number(b.preferences.feedback[topDrivers.bestModel.id])
                : 0),
            0
          )
        : 0;

    return topDrivers === undefined ? (
      <div />
    ) : (
      <div className={styles.modelFeedbackContainer}>
        {topDrivers?.bestModel?.label ? (
          <div className={styles.tModelName}>{topDrivers?.bestModel?.label}</div>
        ) : (
          <React.Fragment />
        )}
        <ButtonGroup>
          <Button
            onClick={
              topDrivers.bestModel && topDrivers.bestModel.id !== undefined
                ? () => updateModelFeedback(topDrivers.runId, topDrivers.bestModel.id, true)
                : () => {}
            }
            style={{ padding: "5px" }}
            disabled={isNoInteractions}
          >
            <FontAwesomeIcon icon={faThumbsUp} />
          </Button>
          <Button
            onClick={
              topDrivers.bestModel && topDrivers.bestModel.id !== undefined
                ? () => updateModelFeedback(topDrivers.runId, topDrivers.bestModel.id, false)
                : () => {}
            }
            style={{ padding: "5px" }}
            disabled={isNoInteractions}
          >
            <FontAwesomeIcon icon={faThumbsDown} />
          </Button>
        </ButtonGroup>
        <div className={styles.modelFeedbackNumber}>{(feedbackCount > 0 ? "+" : "") + feedbackCount}</div>
      </div>
    );
  }

  renderModels(activeSlice) {
    const {
      id,
      modelGroups,
      project,
      updateDrilldownValue,
      setup,
      optimized,
      hideTitle,
      isNext,
      isMini,
      frontierModels,
      isNoInteractions
    } = this.props;
    const { mode, sortMode } = this.state;

    if (activeSlice === undefined) {
      return <div className={styles.emptyMessage}>{"Review model drivers here after creating AI"}</div>;
    }

    const sortedModels = this.modelOrganizer(activeSlice);
    const generateFids = () => {
      let ids = this.props.frontierModels && this.props.frontierModels.map((a) => a.id);
      return new Set(ids);
    };
    const fids = generateFids();
    const topDrivers = activeSlice?.runId && modelGroups?.topDrivers?.find((top) => top.runId === activeSlice.runId);

    return (
      <div>
        <React.Fragment>
          <div className={isNext ? styles.mSectionNext : styles.mSection} style={isNext ? { paddingTop: "0px" } : {}}>
            {hideTitle !== true && (
              <div
                className={isNext ? styles.nextSubTitle : styles.subTitle}
                style={
                  activeSlice.color
                    ? {
                        backgroundColor: activeSlice?.value === "Overall" ? "#7E69D7" : activeSlice.color,
                        color: activeSlice?.value === "Overall" ? "#FFFFFF" : undefined
                      }
                    : {}
                }
              >
                {activeSlice?.value}
                {activeSlice.runCost && !isNoInteractions ? (
                  <div className={styles.tSpentBox}>
                    {"Total Spent: $" + (activeSlice.runCost ? activeSlice.runCost.toFixed(2) : "")}
                  </div>
                ) : (
                  <React.Fragment />
                )}
                {topDrivers && this.renderDrivers(topDrivers)}
              </div>
            )}
            {isNext ? (
              <div
                className={styles.overallCol}
                style={{
                  height: isMini ? "260px" : isNext ? "calc(100vh - 275px)" : "400px",
                  marginLeft: hideTitle === true ? "0px" : "20px",
                  paddingRight: "20px"
                }}
              >
                {frontierModels?.length === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexFlow: "column"
                    }}
                  >
                    <LoadingIndicactor />
                    <div>Loading...</div>
                  </div>
                ) : (
                  <div className={styles.chartHolder}>
                    {/* <FeatureChartContainer
                    id={activeSlice?.runId}
                    isHideSelect
                    predictMode={"predict"}
                    featureStyle={{
                      border: "none",
                      margin: "0px",
                      background: isNext ? "transparent" : "white",
                    }}
                    isTabMini
                    isProjectOverview
                    projectId={id}
                    hideRight
                    isNext
                    suppressSelection
                  /> */}
                    <FeatureChartContainer
                      id={activeSlice?.runId}
                      label={"Click to see more information about each variable"}
                      predictMode={"drivers"}
                      isResults
                      isUnified
                      fids={fids}
                      // onClick={() =>
                      //   this.updateSelectedTab(SECTIONS.PREDICTION_DRIVERS)
                      // }
                      isNext
                      projectId={id}
                      singleWindowMode
                      isNoInteractions={isNoInteractions}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className={styles.oneHolder}>
                {sortedModels &&
                  sortedModels.map((model, i) => (
                    <ModelContainer
                      key={i}
                      index={i}
                      data={activeSlice}
                      mode={mode}
                      modelGroups={modelGroups}
                      hideSubgroup
                      color={activeSlice?.color}
                      optimized={optimized}
                      model={model}
                      projectId={id}
                      runId={activeSlice?.runId}
                      setup={setup}
                      sortMode={sortMode}
                      showExcludeToggle
                      enableHoverNavigation
                      viewTestPredictions={this.viewTestPredictions}
                    />
                  ))}
              </div>
            )}
          </div>
        </React.Fragment>
      </div>
    );
  }

  renderModelsOverall() {
    const {
      id,
      modelGroups,
      project,
      updateDrilldownValue,
      setup,
      isNext,
      nextId,
      hideTitle,
      optimized,
      isNoInteractions,
      isMini
    } = this.props;
    const { mode, sortMode } = this.state;

    return (
      <div>
        {modelGroups &&
          modelGroups.drilldownValues &&
          modelGroups.drilldownValues
            .filter((d) => d.value !== "Overall" || (project && project.segments.length === 1))
            .map((d, index) => {
              const topDrivers = d?.runId && modelGroups?.topDrivers?.find((top) => top.runId === d.runId);

              const isRunning = d?.bestModel === undefined;

              return (
                <React.Fragment key={d.runId}>
                  <div
                    className={styles.mSection}
                    style={
                      isNext
                        ? {
                            marginTop: "0px",
                            // marginBottom: "10px",
                            borderTop: index === 0 ? "0px" : "",
                            paddingTop: !isNext && index > 0 ? "10px" : "0px"
                          }
                        : {}
                    }
                  >
                    {hideTitle !== true && (
                      <div
                        className={isNext ? styles.nextSubTitle : styles.subTitle}
                        style={d.color ? { backgroundColor: d.color } : {}}
                      >
                        {d.value}
                        {!isNext && (
                          <React.Fragment>
                            {" - "}
                            <a onClick={() => updateDrilldownValue(d.runId, d.value)}>{"View All"}</a>
                          </React.Fragment>
                        )}
                        {d.runCost && !isNoInteractions ? (
                          <div className={styles.tSpentBox}>
                            {"Total Spent: $" + (d.runCost ? d.runCost.toFixed(2) : "")}
                          </div>
                        ) : (
                          <React.Fragment />
                        )}
                        {topDrivers && this.renderDrivers(topDrivers)}
                      </div>
                    )}
                    {isRunning ? (
                      <div
                        className={styles.overallCol}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: isMini ? "270px" : undefined
                        }}
                      >
                        <LoadingIndicactor style={{ margin: "0px" }} />
                      </div>
                    ) : isNext ? (
                      <div
                        className={styles.overallCol}
                        style={{
                          marginLeft: hideTitle ? "0px" : undefined,
                          height: isMini ? "270px" : undefined
                        }}
                      >
                        <div className={styles.chartHolder}>
                          <FeatureChartContainer
                            id={d.runId}
                            isHideSelect
                            predictMode={"predict"}
                            featureStyle={{
                              border: "none",
                              margin: "0px",
                              background: "white"
                            }}
                            isTabMini
                            isProjectOverview
                            projectId={id}
                            hideRight
                            isNext
                            suppressSelection
                            isNoInteractions
                          />
                        </div>
                      </div>
                    ) : (
                      <div className={styles.mHolder}>
                        {d.modelList &&
                          d.modelList &&
                          this.modelOrganizer(d)
                            .filter((model, i) => i < 3)
                            .map((model, i) => (
                              <ModelContainer
                                key={i}
                                index={i}
                                hideBest={i !== 0}
                                data={d}
                                mode={mode}
                                modelGroups={modelGroups}
                                hideSubgroup
                                color={d.color}
                                model={model}
                                runId={d.runId}
                                projectId={id}
                                setup={setup}
                                sortMode={sortMode}
                                showExcludeToggle
                                enableHoverNavigation
                                viewTestPredictions={this.viewTestPredictions}
                              />
                            ))}
                      </div>
                    )}
                  </div>
                </React.Fragment>
              );
            })}
      </div>
    );
  }

  viewTestPredictions = async (model) => {
    const { updateDrilldownValue, updateSelectedModel, runId } = this.props;
    if (model.subgroup.runId !== runId) {
      await updateDrilldownValue(model.subgroup.runId, model.subgroup.value);
    }
    await updateSelectedModel(model.value.id);
    this.setState({ selectedModel: model });
  };

  componentWillUnmount() {
    this.setState({ selectedModel: null });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.runId !== this.props.runId) {
      this.setState({ selectedModel: null });
    }
  }

  render() {
    const {
      id,
      isContinuous,
      modelGroups,
      runId,
      optimized,
      hideModelBox,
      setup,
      revenueLabel,
      profitLabel,
      costLabel,
      isNext,
      isMini
    } = this.props;
    const { mode, sortMode } = this.state;

    const activeSlice =
      modelGroups &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.runId === runId).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.runId === runId)[0]
        : undefined;

    const overallOnly = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length < 2;

    let objective = profitLabel ? profitLabel : "Impact";

    const sortOptions = [
      { label: objective, value: "PROFIT" },
      { label: revenueLabel, value: "REVENUE" },
      { label: "Resourcing", value: "RESOURCING" },
      { label: "Accuracy", value: "ACCURACY" },
      { label: "Recall", value: "RECALL" },
      { label: "Precision", value: "PRECISION" },
      { label: "Log Loss", value: "LOGLOSS" }
    ];

    return (
      <div className={styles.modelList}>
        {hideModelBox !== true && (
          <div className={styles.right}>
            <div className={styles.modelBox} style={{ position: "relative" }}>
              <ModelBoxContainer
                id={id}
                runId={runId}
                isSmall={overallOnly || this.getIsOverallSegment()}
                showSubgroup={!overallOnly && !this.getIsOverallSegment()}
                modelsTab
              />
            </div>
          </div>
        )}
        {!this.state.selectedModel ? (
          <React.Fragment>
            <div
              className={hideModelBox !== true ? styles.mLeft : styles.fLeft}
              style={isNext ? { padding: "0px 0px" } : {}}
            >
              {isNext ? (
                <div />
              ) : isContinuous ? (
                <div className={styles.mTitle + " " + styles.mFlex} style={{ marginBottom: "5px" }}>
                  <span>{"AI Models Ranked by Impact for your business"}</span>
                </div>
              ) : (
                <div className={styles.mTitle + " " + styles.mFlex} style={{ marginBottom: "5px" }}>
                  <span>{"AI Models Ranked by Max Potential"}</span>
                  <span
                    style={{
                      width: "200px",
                      marginLeft: "10px",
                      marginRight: "10px"
                    }}
                  >
                    <Select
                      options={sortOptions}
                      onChange={(val) => this.setState({ sortMode: val.value })}
                      value={
                        sortOptions.filter((s) => s.value === sortMode).length > 0
                          ? sortOptions.filter((s) => s.value === sortMode)[0]
                          : undefined
                      }
                    />
                  </span>
                  <span>{" for your Business"}</span>
                </div>
              )}
              {isNext !== true && (
                <div className={styles.headerTabs}>
                  <ButtonGroup>
                    <Button active={mode === "MODEL"} onClick={() => this.setState({ mode: "MODEL" })}>
                      {"Overview"}
                    </Button>
                    <Button active={mode === "DETAILS"} onClick={() => this.setState({ mode: "DETAILS" })}>
                      {"Model Details"}
                    </Button>
                  </ButtonGroup>
                </div>
              )}
              <div
                className={hideModelBox !== true ? "" : styles.mListHolder}
                style={
                  isNext
                    ? {
                        margin: "0px",
                        height: isMini ? "320px" : "calc(100vh - 220px)"
                      }
                    : {}
                }
              >
                {activeSlice &&
                activeSlice.column === "Overall" &&
                modelGroups &&
                modelGroups.drilldownValues.length > 1
                  ? this.renderModelsOverall()
                  : this.renderModels(activeSlice)}
              </div>
            </div>
            {hideModelBox !== true && (
              <div className={styles.right}>
                <div className={styles.modelBox}>
                  <ModelBoxContainer
                    id={id}
                    runId={runId}
                    isSmall={overallOnly || this.getIsOverallSegment()}
                    showSubgroup={!overallOnly && !this.getIsOverallSegment()}
                  />
                </div>
              </div>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div style={{ width: "95%" }}>
              <div className={styles.mLeft}>
                <div className={styles.mTitle} style={{ marginBottom: "5px" }}>
                  {`AI Models Ranked by Potential ${objective} for Your Business`}
                </div>
              </div>
              <div style={{ display: "flex" }}>
                {this.state.selectedModel && (
                  <div style={{ marginTop: "5px", marginLeft: "40px" }}>
                    <div className={styles.subTitle} style={{ paddingBottom: "10px" }}>
                      {`Selected Model`}
                    </div>
                    <ModelContainer
                      data={activeSlice}
                      mode={"MODEL"}
                      hideBest
                      modelGroups={modelGroups}
                      hideSubgroup
                      color={activeSlice.color}
                      model={this.state.selectedModel.value}
                      runId={activeSlice.runId}
                      setup={setup}
                      showExcludeToggle
                      viewTestPredictions={this.viewTestPredictions}
                    />
                  </div>
                )}
                <div style={{ width: "100%" }}>
                  <TestPredictionsContainer
                    {...this.props}
                    id={optimized && optimized.innerId !== undefined ? optimized.innerId : "new"}
                    projectId={id}
                    aibleBusiness
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex",
                  width: "95%"
                }}
              >
                <Button onClick={() => this.setState({ selectedModel: null })}>Back to Models</Button>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}
